<template>
    <v-container fluid id="home" class="fill-height">
        <v-snackbar v-model="snackbar" :timeout="4000" top color="red">
            <span>Incorrect Login Details</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="pa-7" id="login">
                    
                    <h2 class="white--text text-center">LOGIN</h2>
                    <v-card-text>
                        <v-form>
                            <v-text-field  solo flat label="Username"  prepend-inner-icon="mdi-account" name="username" v-model="username" type="text" color="#08911B">

                            </v-text-field>
                            <v-text-field class="mt-7" color="#08911B" solo flat label="Password" name="password" v-model="password"
                             :append-icon="show1 ? 'visibility' : 'visibility_off'"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                             prepend-inner-icon="mdi-lock"
                              >
                            </v-text-field>
                         <v-card-text class="text-right">
                            <v-btn text class="white--text forgot mt-n9" router-link to="/forgot">Forgot Password?</v-btn>
                        </v-card-text>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <div class="mx-auto">
                        <v-btn width="150" large color="#FFFFFF"  :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" style="color:#62AE32" v-on:click="login()">
                            Login
                        <v-icon right>mdi-login</v-icon>
                        </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name:'Login',
    data(){
        return{
            username:"",
            password:"",
            show1: false,
            loading: false,
            snackbar:false
        }
    },
    methods:{
        login(){
            this.loading = true
            this.$store.dispatch("Login", {
            "username": this.username,
            "password": this.password
            })
        .then(()=>{
          this.loading = false
          this.$router.push('/dashboard'); 
        //   this.$router.push('/fluttertest'); 
        })
        .catch((error)=>{
          if(error.response.status===400){
            this.loading = false;
            this.snackbar = true;
          }else{
            this.loading = false
          }
          
        });
      }

    }
}
</script>
<style  scoped>
    #home{
        background: url('/mainBackground.png');
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    
    #login{
        background: rgba(98, 174, 50, 0.7);
        border-radius: 5px;
    }
    .forgot{
        text-transform: capitalize;
    }
</style>